import './create-nonce';

import {StripesTheme} from '@zebra-fed/zds-react-desktop/StripesTheme';
import React from 'react';
import {BrowserRouter as Router, Route, Switch} from 'react-router-dom';

import {SSOSettingsProvider} from './authentication/SSOSettings';
import {AuthProvider} from './authentication/Auth';
import IdleTimerContainer from './components/IdleTimeContainer';
import {LoginPage} from './pages';
import RouteRestricter from './routing/RouteRestricter';
import {MessageLocalizationProvider} from "./data/MessageLocalizationProvider";

function App() {

  return (
      <MessageLocalizationProvider>
        <SSOSettingsProvider>
          <AuthProvider>
              <IdleTimerContainer/>
              <Router>
                <StripesTheme>
                  <Switch>
                    <Route path='/login'>
                      <LoginPage/>
                    </Route>
                    <RouteRestricter/>
                  </Switch>
                </StripesTheme>
              </Router>
          </AuthProvider>
        </SSOSettingsProvider>
      </MessageLocalizationProvider>
  );
}

export default App;
